import { createContext } from "react";
class Context {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
  }
  static create() {
    if (!Context.instance) {
      Context.instance = new Context();
    }
    return Context.instance;
  }
  createContext(key, initialValue) {
    const context2 = createContext(initialValue);
    this.cache.set(key, context2);
    return context2;
  }
  get(key, initialValue) {
    return this.cache.get(key) || this.createContext(key, initialValue);
  }
}
const context = Context.create();
const context$1 = context;
export {
  context$1 as default
};
//# sourceMappingURL=Context.js.map
